"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNamedClass = isNamedClass;
exports.extendContext = extendContext;
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/ban-types */
const log_client_1 = require("@video/log-client");
const common_1 = require("../../utils/common");
const context_1 = require("./context/context");
function isNamedClass(klass) {
    return typeof Reflect.get(klass, "displayName") === "string";
}
function extendContext(ctx, klass) {
    return (0, context_1.context)({
        logger: new log_client_1.LoggerCore(common_1.PACKAGE_NAME).extend(ctx.logger).appendChain(klass),
        chain: `${ctx.chain}:${klass.displayName}`,
    }, ctx);
}
//# sourceMappingURL=logger.js.map